export default {"src":"/_next/static/media/aboutIcon.6e2412cb.svg","height":16,"width":10};